import { render } from "./TopicPost.vue.js?vue&type=template&id=3af62c73!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicPost.vue?vue&type=template&id=3af62c73"
import script from "./TopicPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicPost.vue?vue&type=script&lang=js"
export * from "./TopicPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/TopicPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3af62c73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3af62c73', __exports__)) {
    api.reload('3af62c73', __exports__)
  }
  
  module.hot.accept("./TopicPost.vue.js?vue&type=template&id=3af62c73!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TopicPost.vue?vue&type=template&id=3af62c73", () => {
    api.rerender('3af62c73', render)
  })

}


export default __exports__